let swipers; // 전역 변수 선언

function initializeSwiper(simulateTouch) {
    let swiper = new Swiper(".thumbnail-swiper", {
        cssMode: true,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        on: {
            init: function () {
                addSlideNumbers(this);
            },
        }
    });

    let direction = simulateTouch ? 'horizontal' : 'vertical';
    let mousewheel = !simulateTouch;
    let freeMode = !simulateTouch;

    let mainSwiperOptions = {
        direction: direction,
        mousewheel: mousewheel,
        freeMode: freeMode,
        simulateTouch: simulateTouch,
        thumbs: {
            swiper: swiper,
        },
        on: {
            init: function () {
                addSlideNumbers(this);
            },
            reachEnd: function () {
                if (this.isEnd) {
                    this.mousewheel.disable();
                }
            }
        }
    };

    if (!simulateTouch) {
        // mainSwiperOptions.speed = 0;
    }

    let swiper2 = new Swiper(".product-swiper", mainSwiperOptions);

    return {swiper, swiper2};  // Swiper 인스턴스 반환
}

function addSlideNumbers(swiperInstance) {
    swiperInstance.slides.forEach((slide, index) => {
        const slideNumber = (index + 1).toString().padStart(2, '0');

        const productImageInner = slide.querySelector('.product-image-inner');

        if (productImageInner) {
            if (!productImageInner.querySelector('.slide-index')) {
                const numberElement = document.createElement('div');
                numberElement.className = 'slide-index';
                numberElement.textContent = slideNumber;
                productImageInner.appendChild(numberElement);
            } else {
                productImageInner.querySelector('.slide-index').textContent = slideNumber;
            }
        }
    });
}

function enableSwiperWheelOnScrollTop() {
    if (window.scrollY === 0) {
        swipers.swiper2.mousewheel.enable(); // Swiper의 휠 기능 활성화
    }
}

// 초기화시 방향 설정
let simulateTouch = window.matchMedia("(max-width: 1024px)").matches;
swipers = initializeSwiper(simulateTouch); // Swiper 초기화

// 스크롤 이벤트 감지
window.addEventListener('scroll', enableSwiperWheelOnScrollTop);

window.matchMedia("(max-width: 1024px)").addEventListener('change', (e) => {
    simulateTouch = e.matches;
    swipers.swiper2.destroy(true, true);
    swipers.swiper.destroy(true, true);
    swipers = initializeSwiper(simulateTouch); // 다시 초기화
});
